module.exports = __webpack_public_path__ + "assets/img/help_image02-2.e734ab52.png";